import { UsersRound } from "lucide-react";

const manifest = {
  key: "preferred_vendors_management",
  isFreeModule: false,
  isPurchasable: false,
  icon: UsersRound,
  names: {
    plan: {
      en: "Preferred Vendors Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0631\u062f\u064a\u0646 \u0627\u0644\u0645\u0641\u0636\u0644\u064a\u0646",
      "zh-Hans": "首选供应商管理",
    },
    dashboard: {
      en: "Preferred Vendors Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0631\u062f\u064a\u0646 \u0627\u0644\u0645\u0641\u0636\u0644\u064a\u0646",
      "zh-Hans": "首选供应商管理",
    },
  },
  defaultPath: "/preffered-supplier",
  matchers: [/^\/preffered-supplier(?:\/|$)/],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__preferred_vendors__",
      children: [{ label: t("preferredSuppliers"), path: "/preffered-supplier" }],
    },
  ],
};

export default manifest;
